import { Vue, Options } from 'vue-class-component';
import { PropType } from 'vue';
import {
  AggregateCommandActionListItemDTO,
  SceneActionListItemDTO,
  SceneActionsListsDTO,
} from '@/../client-generator/generated-clients/plants';

import AggregateCommandAccordion from './AggregateCommandAccordion/AggregateCommandAccordion.vue';
import DialogAddAction from '../DialogAddAction/DialogAddAction.vue';
import { cloneObject } from '@/core/utils/utils';

@Options({
  name: 'ScenePanelAggregateCommands',
  props: {
    aggregateCommands: {
      required: true,
      type: Object as PropType<AggregateCommandActionListItemDTO[]>,
    },
  },
  components: {
    AggregateCommandAccordion,
    DialogAddAction,
  },
  emits: ['add-action'],
})
export default class ScenePanelAggregateCommands extends Vue {
  aggregateCommands!: AggregateCommandActionListItemDTO[];
  isVisibleDialogAddAction = false;
  tempActionToAdd: SceneActionsListsDTO | null = null;

  openShowDialogAction(object: SceneActionListItemDTO) {
    this.tempActionToAdd = cloneObject(object);
    this.isVisibleDialogAddAction = true;
  }

  handleDoAddAction() {
    this.$emit('add-action', this.tempActionToAdd);
  }
}
